import { loadCldr } from "@syncfusion/ej2-base";

let hasLoadedEs = false;

async function loadLocalEs() {
  const [currencies, gregorian, numbers, timeZoneNames, numberingSystems, weekData] = await Promise.all([
    import("../cldr/main/es/currencies.json"),
    import("../cldr/main/es/ca-gregorian.json"),
    import("../cldr/main/es/numbers.json"),
    import("../cldr/main/es/timeZoneNames.json"),
    import("../cldr/supplemental/numberingSystems.json"),
    import("../cldr/supplemental/weekData.json"),
  ]);
  loadCldr(
    currencies.default,
    numberingSystems.default,
    gregorian.default,
    numbers.default,
    timeZoneNames.default,
    weekData.default
  );
}

export async function ensureCldrEsLoaded() {
  if (hasLoadedEs) return;
  await loadLocalEs();
  hasLoadedEs = true;
}

